import React, { useState } from "react";

import { mdiPageFirst } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import type { JSX } from "react";

interface Props {
  title?: string | null;
  children: React.ReactNode;
}

function Collapsed({ title, children }: Props): JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const handleCollapse = (): void => {
    setIsCollapsed(!isCollapsed);
  };

  const containerTitleAndButtonClassNames = classNames(
    "flex",
    isCollapsed ? "h-full flex-col-reverse" : "flex-row",
  );
  const containerTitleClassNames = classNames(
    "m-auto",
    isCollapsed
      ? "min-w-[30px] mt-[0.46875rem] h-full w-auto rounded-[0.3125rem] px-[0.3125rem] py-[1.25rem] ring-1 ring-inset ring ring-input bg-card"
      : "w-full",
  );
  const titleClassNames = classNames(
    "text-[1.171875rem] font-semibold",
    isCollapsed && "-rotate-180 whitespace-nowrap [writing-mode:vertical-lr]",
  );
  const iconCollapseClassNames = classNames(isCollapsed && "rotate-180");

  return (
    <div className="flex flex-col overflow-hidden">
      <div className={containerTitleAndButtonClassNames}>
        {title ? (
          <div className={containerTitleClassNames}>
            <div className={titleClassNames}>{title}</div>
          </div>
        ) : null}
        <button
          className="bg-card ring-input cursor-pointer rounded-[0.3125rem] p-1 ring ring-1 ring-inset"
          onClick={handleCollapse}
          type="button"
        >
          <Icon
            className={iconCollapseClassNames}
            path={mdiPageFirst}
            size={1}
          />
        </button>
      </div>
      {!isCollapsed && <div className="h-[calc(100%-35px)]">{children}</div>}
    </div>
  );
}

export default Collapsed;
